// extracted by mini-css-extract-plugin
export var dataCell = "_sd-2";
export var dataRow = "_sd-0";
export var headerRow = "_sd-1";